<template>
    <!-- 集团管理-充值配置 -->
    <el-dialog title="充值配置" :visible.sync="show" :before-close="closeDialog" width="60%">
        <!-- 基本信息表单 -->
        <div class="form-box">
  
                <el-form label-width="180px" ref="form" :model="submit_data" style="height: 400px; overflow-y: auto">
                    <el-form-item>
                        <span>充值优惠方式 : </span>

                        <el-select v-model="submit_data.activity_status" placeholder="请选择" clearable>
                            <el-option label="关闭" value="0"> </el-option>

                            <el-option label="按固定金额" value="1"> </el-option>
                            <el-option label="按百分比" value="2"> </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <div v-if="submit_data.activity_status == 1">
                            <div class="jt-border">
                                <div>
                                    <span class="jd-span">按固定金额充值配置:</span>
                                    <!-- 加减号按钮 -->
                                    <div class="jia-jian-btn">
                                        <el-button
                                            @click="addContent()"
                                            type="success"
                                            class="jia-jian-btn1"
                                            icon="el-icon-plus"
                                        ></el-button>

                                        <el-button
                                            @click="subContent()"
                                            type="danger"
                                            class="jia-jian-btn1"
                                            icon="el-icon-minus"
                                        ></el-button>
                                    </div>
                                </div>
                                <div class="driver-naturl" v-for="(item, index) in regular_arr" :key="index">
                                    <div class="jt-input">
                                        <span class="span_group">充值</span
                                        ><el-input v-model="item[0]" placeholder="金额（元）" class="jt-input-val"> </el-input>
                                    </div>
                                    <div class="jt-input">
                                        <span>赠送</span
                                        ><el-input v-model="item[1]" placeholder="金额（元）" class="jt-input-val"> </el-input>
                                    </div>
                                </div>
                            </div>
                            <div class="driver-naturl exceed_group">
                                <div class="jt-input">
                                    <span>超出充值金额</span
                                    ><el-input v-model="exceed_amount_start" placeholder="金额（元）" class="jt-input-val"> </el-input>
                                </div>
                                <div class="jt-input">
                                    <span>最多赠送</span
                                    ><el-input v-model="exceed_amount_end" placeholder="金额（元）" class="jt-input-val"> </el-input>
                                </div>
                            </div>
                        </div>

                        <div v-if="submit_data.activity_status == 2" style="display: flex; justify-content: start">
                            <span>充值赠送百分比:</span
                            ><el-input v-model="submit_data.proportion" placeholder="大于等于0的数字" class="jt-input-val"> </el-input>
                        </div>
                    </el-form-item>
                </el-form>


            <div style="display: flex; justify-content: center">
                <submitBtn
                    @onSubmitDig="onSubmitDig"
                    :data="submit_data"
                    :rules="submit_rules"
                    :url="submit_url"
                    :JSON_Boolean="true"
                    @toJSON="toJSON"
                ></submitBtn>
                <!-- <el-button type="primary" @click="activiteSubmit">保存</el-button> -->
                <el-button @click="closeDialog">关闭</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
var _this;

export default {
    props: {
        isShow: Boolean,
        data: ''
    },
    watch: {
        isShow(newData, oldData) {
            _this.show = true;
            _this.submit_data.group_wallet_code = _this.data;

            _this.walletInit();
        }
    },
    data() {
        return {
            submit_url: '/group/activiteConf',

            exceed_amount_start: '', // 超出充值金额 v-model绑定值
            exceed_amount_end: '', // 最多赠送 v-model绑定值
            regular_arr: [],
            exceed_arr: [],

            show: false,

            // 表单提交数据
            submit_data: {
                group_wallet_code: '',
                activity_status: '', // 充值优惠方式
                regular: '', // 固定金额数组
                exceed: '', // 超出充值金额和最多赠送合并的数组
                proportion: '' // 充值优惠方式按百分比的时候，充值赠送百分比
            },

            submit_rules: {
                activity_status: {
                    placeholder: '充值优惠方式',
                    rules: {
                        required: false,
                        message: '充值优惠方式',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                },
                regular: {
                    placeholder: '充值数组',
                    rules: {
                        required: false,
                        message: '充值数组为大于0的数字',
                        regulation: 'none',
                        rulesData: 0
                    }
                },
                exceed: {
                    placeholder: '超出充值金额',
                    rules: {
                        required: false,
                        message: '超出充值金额为大于0的数字',
                        regulation: 'none',
                        rulesData: 0
                    }
                },
                proportion: {
                    placeholder: '按百分比',
                    rules: {
                        required: false,
                        message: '按百分比',
                        regulation: 'egt',
                        rulesData: 0
                    }
                }
            }
        };
    },
    created() {
        _this = this;
    },
    methods: {
        addContent() {
            if (_this.regular_arr.length >= 6) {
                this.$message.error('充值配置应该小于6个！');
                return;
            }
            _this.regular_arr.push([]);
        },
        subContent() {
            _this.regular_arr.pop();
        },
        // 充值配置
        walletInit() {
            _this
                .$post('/group/getGroupWalletDetails', {
                    group_wallet_code: _this.submit_data.group_wallet_code
                })
                .then((res) => {
                    // 将获取到的数据赋值

                    _this.regular_arr = res.data.regular;
           

                    _this.exceed_amount_start = res.data.exceed[0];
                    _this.exceed_amount_end = res.data.exceed[1];

                    _this.submit_data.activity_status = res.data.activity_status.val;
                    _this.submit_data.proportion = res.data.proportion;
                })
                .catch((err) => {});
        },
        // 关闭方法
        closeDialog() {
            _this.show = false;

            _this.submit_data = {
                group_wallet_code: '',
                activity_status: '',
                regular: '',
                exceed: '',
                proportion: ''
            };
        },

        toJSON() {
            if (_this.submit_data.activity_status == 1) {
                // 如果充值优惠方式是按固定金额
             
                 _this.submit_rules['regular']={
                    placeholder: '充值数组',
                    rules: {
                        required: true,
                        message: '充值数组为大于0的数字',
                        regulation: 'arr_number',
                        rulesData: 0
                    }
                };
                 _this.submit_rules['exceed']={
                    placeholder: '超出充值金额',
                    rules: {
                        required: true,
                        message: '超出充值金额为大于0的数字',
                        regulation: 'arr_child',
                        rulesData: 0
                    }
                };
                

                delete _this.submit_data.proportion;
                delete _this.submit_rules.proportion;

                if (_this.regular_arr.length != 0 || _this.exceed_arr.length != 0) {
                    _this.submit_data.regular = JSON.stringify(_this.regular_arr);

                    _this.exceed_arr = [_this.exceed_amount_start, _this.exceed_amount_end];

                    _this.submit_data.exceed = JSON.stringify(_this.exceed_arr);
                } else {
                    _this.submit_data.regular = '';

                    _this.submit_data.exceed = '';
                }
            }
            if (_this.submit_data.activity_status == 2) {
                // 如果充值优惠方式是按百分比

                _this.submit_rules['proportion']={
                    placeholder: '按百分比',
                    rules: {
                        required: true,
                        message: '按百分比',
                        regulation: 'egt',
                        rulesData: 0
                    }
                };
                delete _this.submit_rules.regular;
                delete _this.submit_rules.exceed;
                delete _this.submit_data.exceed;
                delete _this.submit_data.regular;
            }
            if (_this.submit_data.activity_status == 0) {
                
                delete _this.submit_rules.regular;
                delete _this.submit_rules.exceed;
                delete _this.submit_data.exceed;
                delete _this.submit_data.regular;
                delete _this.submit_data.proportion;
                delete _this.submit_rules.proportion;
            }
        },
        // 提交
        onSubmitDig() {
            // 触发父组件自定义事件刷新表格
            _this.$emit('onSubmit');
            _this.closeDialog();
        },
  
    }
};
</script>

<style scoped>
.span_group {
    display: inline-block;
}
.jt-border {
    background-color: #fff;
    border-radius: 10px;
    padding: 20px;
    margin-top: 20px;
    border: 1px solid #efefef;
    margin-bottom: 10px;

    width: 80%;
}
.jd-span {
    color: #606266;
    margin-right: 150px;
}
.jia-jian-btn {
    display: inline-block;
    margin-bottom: 0px;
}
.jia-jian-btn1 {
    width: 50px;
    height: 40px;
}
.driver-naturl {
    display: flex;
    justify-content: space-between;
    color: #606266;
}
.driver-naturl.exceed_group {
    width: 85%;
}
.jt-input {
    margin: 10px 20px;
}
.jt-input-val {
    width: 50%;
    margin-left: 10px;
}

.form-box {
    padding: 20px;
    box-sizing: border-box;
    /* margin-right: 0; */
    width: 100%;
}
</style>
